import * as React from "react";
import GoldLink from "src/presentation/common/atom/btn/gold_link";
import styled from "styled-components";
import { customerConfig } from "../../../../../config/language/ja-JP/domain/model_text";
import { ConstBreakPoint } from "../../../../../config/styles_const/styles_const";
import { Customer, Language } from "../../../../../domain/model/customer";
import AvatarLarge from "../../../../common/atom/avatar/avatar_large";
import HeadlineMiddle from "../../../../common/atom/text/headline_middle";
import ParagraphSup from "../../../../common/atom/text/paragraph_sup";
import ProfileRightBtnWrapper from "../../../../common/atom/wrapper/profile_right_btn_wrapper";

interface IProps {
  customer: Customer;
}

const CustomerProfile: React.FC<IProps> = (props) => {
  const { customer } = props;
  const createLanguageList: string[] = customer.languages.map(
    (item: Language) => {
      return customerConfig.languageList[item];
    }
  );
  return (
    <React.Fragment>
      <Wrapper>
        <EditButtonContainer>
          <ProfileRightBtnWrapper>
            <ButtonWrapper>
              <EditLink to={"/customer/mypage/customer/_edit"}>
                編集する
              </EditLink>
            </ButtonWrapper>
          </ProfileRightBtnWrapper>
        </EditButtonContainer>
        <Section>
          <AvatarLarge src={customer.getIconURL()} />
          <div style={{ marginLeft: 15 }}>
            <ParagraphSup bold={true}>{customer.nameKana}</ParagraphSup>
            <HeadlineMiddle>{customer.name}</HeadlineMiddle>
            <Text>{customer.pr}</Text>
          </div>
        </Section>
        <Section>
          <div style={{ flex: "1" }}>
            <InfoTitle>
              個人情報
              <span
                style={{
                  fontSize: 12,
                  fontWeight: "normal",
                  color: "#CE4141",
                  display: "inline-block",
                  paddingLeft: 16,
                }}
              >
                ※法人へは個人情報は表示されません。
              </span>
            </InfoTitle>
            <InfoArea>
              <div style={{ display: "flex", marginBottom: 16 }}>
                <InfoLabel>性別</InfoLabel>
                <InfoValue>
                  {customerConfig.genderList.get(customer.gender)}
                </InfoValue>
              </div>
              <div style={{ display: "flex", marginBottom: 16 }}>
                <InfoLabel>生年月日</InfoLabel>
                <InfoValue>{customer.getBirthdateString()}</InfoValue>
              </div>
              <div style={{ display: "flex", marginBottom: 16 }}>
                <InfoLabel>電話番号</InfoLabel>
                <InfoValue>{customer.phoneNumber}</InfoValue>
              </div>
              <div style={{ display: "flex", marginBottom: 16 }}>
                <InfoLabel>Email</InfoLabel>
                <InfoValue>{customer.email}</InfoValue>
              </div>
            </InfoArea>
          </div>
          <div style={{ flex: "1" }}>
            <InfoTitle>その他情報</InfoTitle>
            <InfoArea>
              <div style={{ display: "flex", marginBottom: 16 }}>
                <InfoLabel>所在地</InfoLabel>
                <InfoValue>{customer.address}</InfoValue>
              </div>
              <div style={{ display: "flex", marginBottom: 16 }}>
                <InfoLabel>学歴</InfoLabel>
                <InfoValue>{customer.academicBackgrounds.toString()}</InfoValue>
              </div>
              <div style={{ display: "flex", marginBottom: 16 }}>
                <InfoLabel>資格</InfoLabel>
                <InfoValue>{customer.requirements.toString()}</InfoValue>
              </div>
              <div style={{ display: "flex", marginBottom: 16 }}>
                <InfoLabel>語学</InfoLabel>
                <InfoValue>{createLanguageList.toString()}</InfoValue>
              </div>
              <div style={{ display: "flex", marginBottom: 16 }}>
                <InfoLabel>ポートフォリオ</InfoLabel>
                <InfoValue>
                  <a href={customer.portfolio} target="_blank">
                    {customer.portfolio}
                  </a>
                </InfoValue>
              </div>
              <div style={{ display: "flex", marginBottom: 16 }}>
                <InfoLabel>出身地</InfoLabel>
                <InfoValue>{customer.birthplace}</InfoValue>
              </div>
            </InfoArea>
          </div>
        </Section>
      </Wrapper>
    </React.Fragment>
  );
};

export default CustomerProfile;

const Wrapper = styled.div`
  margin: 40px auto;
`;

const Section = styled.div`
  display: block;
  text-align: center;
  margin-bottom: 40px;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    display: flex;
    text-align: left;
  }
`;

const Text = styled.div`
  margin-top: 50px;
  font-size: 12px;
  font-weight: normal;
  line-height: 15px;
  white-space: pre-wrap;
`;

const InfoTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  text-align: left;
`;

const InfoArea = styled.div`
  border-left: solid 5px #9a8c64;
  padding-left: 25px;
  margin-top: 20px;
  margin-bottom: 40px;
`;

const InfoLabel = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: bold;
  width: 100px;
  color: #333333;
`;

const InfoValue = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: #333333;
`;

const ButtonWrapper = styled.div`
  margin-left: 10px;
`;

const EditButtonContainer = styled.div`
  display: none;
  margin-top: 40px;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    display: block;
    margin-top: 0px;
  }
`;

const EditLink = styled(GoldLink)`
  font-size: 12px;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/mypage/info/customer_profile.tsx